import { message } from "antd";
import { useState } from "react";
import Invoice from "../../../../../redux/models/invoice";
import K from "../../../../../utilities/constants";

const INITIAL_ERROR_STATE = { message: null, statements: [] };

export const useEditInvoice = (invoiceDetails, onSuccess) => {
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState(INITIAL_ERROR_STATE);

  const clearError = () => setErrorState(INITIAL_ERROR_STATE);

  const onFinish = (closeModal) => async (values) => {
    const { startDate, status, invoiceNumber } = values;
    const isRevert =
      status === K.Invoice.Status.Draft &&
      invoiceDetails?.status !== K.Invoice.Status.Draft;

    try {
      setLoading(true);
      clearError();

      const res = await Invoice.edit(
        {
          invoiceId: invoiceDetails.id,
          invoiceNumber: isRevert ? null : invoiceNumber,
          status,
          startDate: startDate.format(K.DateFormat.Response),
        },
        false,
      );

      onSuccess(res);
      closeModal();
      message.success("Invoice updated successfully");
    } catch (err) {
      setErrorState({
        message: err.message,
        statements: err.error?.data?.errors?.statements ?? [],
      });
      message.error(err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (closeModal) => () => {
    clearError();
    closeModal();
  };

  return {
    loading,
    error: errorState.message,
    errorStatements: errorState.statements,
    onFinish,
    handleClose,
  };
};
